import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";

import Alert from "widgets/alert";
import { setFlagShowDialogCertificate } from "redux/sessionstorage";
import middleware from "configurations/axios";
import apis from "./apis";
import { getRUCEmpresa } from "redux/actions/userActions";
import { useSelector } from "react-redux";
import AffiliationPac from "views/administración/UserAccount/AffiliationPac";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  content: {
    height: "320px"
  }
}));

const DialogAffiliationPac = ({ openDialog, idempresa, onClose }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [updateFileOk, setUpdateFileOk] = useState(false);
  const tokenUser = useSelector((state) => state.user.tk);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    setOpen(openDialog);
    const getCompany = async () => {
      await middleware
        .get(apis.get_company + (tokenUser ? getRUCEmpresa(tokenUser) : "0"))
        .then((response) => {
          if (response.status >= 200 && response.status <= 300) {
            setCompany(response.data);
          }
        })
        .catch((excepcion) => {
          if (excepcion.response) {
            if (excepcion.response.status === 401) {
              //history.push("/");
            }
          } else {
          }
        });
    };
    getCompany();
  }, [openDialog]);

  const handleClose = () => {
    setOpen(false);
    setFlagShowDialogCertificate("N");
    if (typeof onClose === "function") {
      onClose();
    }
    closeAlert();
  };

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleShowAlert = (alert) => {
    setMsg(alert);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Administración de Afiliación al PAC</DialogTitle>
      <DialogContent className={classes.content}>
        <Grid container spacing={3} className={classes.root}>
          <Grid item xs={12}>
            <strong>
              Este apartado te permite afiliar una empresa al PAC.
              El sistema de facturación electrónica necesita que la empresa este afiliada al PAC.
            </strong>
          </Grid>
          <Grid item xs={12}>
            {msgError.show ? (
              <Alert
                tipo={msgError.type}
                mensaje={msgError.msg}
                mesajeSubrayado={null}
                titulo={null}
                mostrar={msgError.show}
                cerrarAlerta={closeAlert}
              />
            ) : null}
            <AffiliationPac data={company} onShowAlert={handleShowAlert}></AffiliationPac>
          </Grid>
          <Grid item md={12} xs={12}>
          </Grid>
          <Grid container xs={12} justify="center" spacing={3}>
            <Grid xs={12} md={3}>
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={handleClose}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAffiliationPac;
